import { CALL_API } from 'middlewares/api';
import { url } from 'configs';

const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_SENDEDDATA_REQUEST = 'tube/stickynotes/sended/FETCH_SENDEDDATA_REQUEST';
const FETCH_SENDEDDATA_SUCCESS = 'tube/stickynotes/sended/FETCH_SENDEDDATA_SUCCESS';
const FETCH_SENDEDDATA_FAIL = 'tube/stickynotes/sended/FETCH_SENDEDDATA_FAIL';

const DELETE_SENDEDDATA_REQUEST = 'tube/stickynotes/sended/DELETE_SENDEDDATA_REQUEST';
const DELETE_SENDEDDATA_SUCCESS = 'tube/stickynotes/sended/DELETE_SENDEDDATA_SUCCESS';
const DELETE_SENDEDDATA_FAIL = 'tube/stickynotes/sended/DELETE_SENDEDDATA_FAIL';

const POST_SENDEDDATA_REQUEST = 'tube/stickynotes/sended/POST_SENDEDDATA_REQUEST';
const POST_SENDEDDATA_SUCCESS = 'tube/stickynotes/sended/POST_SENDEDDATA_SUCCESS';
const POST_SENDEDDATA_FAIL = 'tube/stickynotes/sended/POST_SENDEDDATA_FAIL';

export default function reducer(state = {
  isLoading: false,
  datas: {},
}, action) {
  switch (action.type) {
    case FETCH_SENDEDDATA_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case FETCH_SENDEDDATA_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        datas: action.response,
      });
    default:
      return state;
  }
}

export function fetchSendedData(PageNumber) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'PostNote/Sended?PageNumber=' + PageNumber,
      method: 'GET',
      types: [
        FETCH_SENDEDDATA_REQUEST,
        FETCH_SENDEDDATA_SUCCESS,
        FETCH_SENDEDDATA_FAIL,
      ],
    },
  };
}

export function deleteSendedData(PostNoteToId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'PostNote/Sended/' + PostNoteToId,
      method: 'DELETE',
      types: [
        DELETE_SENDEDDATA_REQUEST,
        DELETE_SENDEDDATA_SUCCESS,
        DELETE_SENDEDDATA_FAIL,
      ],
    },
  };
}

export function postSendedData(Data) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'PostNote/Sended',
      method: 'POST',
      types: [
        POST_SENDEDDATA_REQUEST,
        POST_SENDEDDATA_SUCCESS,
        POST_SENDEDDATA_FAIL,
      ],
      params: Data,
    },
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/StickyNotes/screens/Sended/reducers/index.js
 **/